// Cash-Up Admin tab keys used by src/cashup/AdminPanel.js
export const CASHUP_TAB_KEYS = [
  { key: "staff", label: "Staff Dashboard" },
  { key: "reports", label: "Reports" },
  { key: "managers", label: "Managers" },
  { key: "staff-list", label: "Staff" },
  { key: "active", label: "Active Staff" },
  { key: "labor", label: "Labor" },
  { key: "payroll", label: "Payroll" },
  { key: "settings", label: "Settings" },
  { key: "branding", label: "Branding" },
];

// Defaults requested:
// - Admin: NOT Managers/Payroll/Settings/Branding
// - Viewer: Payroll only
// - Owner: Full access
export const DEFAULT_ROLE_TAB_DEFAULTS = {
  admin: {
    staff: true,
    reports: true,
    managers: false,
    "staff-list": true,
    active: true,
    labor: true,
    payroll: false,
    settings: false,
    branding: false,
  },
  viewer: {
    staff: true,
    reports: true,
    managers: false,
    "staff-list": false,
    active: false,
    labor: false,
    payroll: false,
    settings: false,
    branding: false,
  },
  owner: {
    staff: true,
    reports: true,
    managers: true,
    "staff-list": true,
    active: true,
    labor: true,
    payroll: true,
    settings: true,
    branding: true,
  },
};
